import { render, staticRenderFns } from "./forgot_pass-userdata.vue?vue&type=template&id=679ea310&scoped=true"
import script from "./forgot_pass-userdata.vue?vue&type=script&lang=js"
export * from "./forgot_pass-userdata.vue?vue&type=script&lang=js"
import style0 from "./forgot_pass-userdata.vue?vue&type=style&index=0&id=679ea310&prod&lang=css"
import style1 from "./forgot_pass-userdata.vue?vue&type=style&index=1&id=679ea310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ea310",
  null
  
)

export default component.exports